const RenderPermissions = ({
    categories,
    isLoading,
    permissionsByCategory,
    assignedPermissions,
}) => {
    // Show loading state while permissions are being fetched
    if (isLoading) {
        return (
            <div className="text-xs text-text-secondary">Loading permissions…</div>
        );
    }

    // Show empty state if no categories exist
    if (!categories.length) {
        return (
            <div className="text-xs text-text-secondary">No permissions data.</div>
        );
    }

    const formatCategoryLabel = (cat) =>
    cat
        .replace(/[_-]+/g, " ")
        .split(" ")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

    // Render each permission category
    return categories.map((cat) => {
        const perms = permissionsByCategory[cat] || [];

        // Filter permissions that are already assigned
        const assignedInCat = perms.filter((p) => assignedPermissions.has(p.code) || assignedPermissions.has(p.value));

        return (
            <div
                key={cat}
                className="border border-border-primary/70 rounded-xl p-4 bg-background-icon/10"
            >
                {/* Category header with assigned count */}
                <div className="flex items-center justify-between gap-3">
                    <div className="text-sm font-semibold text-text-primary">
                       {formatCategoryLabel(cat)}
                    </div>

                    <div className="text-xs text-text-secondary">
                        {assignedInCat.length}/{perms.length}
                    </div>
                </div>

                {/* Permission list */}
                <div className="mt-3 space-y-2">
                    {perms.length === 0 ? (
                        // Empty category state
                        <div className="text-xs text-text-secondary">—</div>
                    ) : (
                        perms.map((p) => {
                            const isAssigned =
                                assignedPermissions.has(p.code) ||
                                assignedPermissions.has(p.value);

                            return (
                                <div
                                    key={p.id || p.code}
                                    className="flex items-center gap-2"
                                >
                                    {/* Status indicator dot */}
                                    <span
                                        className={
                                            isAssigned
                                                ? "inline-flex w-2.5 h-2.5 rounded-full bg-button-secondary"
                                                : "inline-flex w-2.5 h-2.5 rounded-full bg-text-primary/20"
                                        }
                                    />

                                    {/* Permission label */}
                                    <span className="text-xs text-text-primary/80 truncate">
                                        {p.displayName || p.code}
                                    </span>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        );
    });
};

export default RenderPermissions;